import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Horse_show_entry } from '../models/horse_show_entry';
import { Horse_show_entry_with_types } from '../models/horse_show_entry_with_types';
import { Horse } from '../models/horse';
import { Person } from '../models/person';
import { Statement } from '../models/accounting/statement';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class PendingHorseShowEntryService {

  constructor(private http: HttpClient) { }


  get(id: string): Promise<Horse_show_entry> {
    return this.getWithRestFragment('id/' + id + '/competitions/true/statement/true/lean/false');
  }


  //Used to verify that user isn't submitting another entry of the same type for the same horse at the same event
  getByHorseId(horse_show_id: string, horse_id: string): Promise<Horse_show_entry_with_types | boolean> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'horse_entries/horse_show_id/' + horse_show_id + '/horse_id/' + horse_id).subscribe((response:any) => {
        if(response.type == 'horse_show_entry_with_types' && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
              if(error_response instanceof HttpErrorResponse){
                switch (error_response.status) {
                  case 401:      //login
                      reject(error_response);
                      break;
                  case 403:     //forbidden
                      reject(error_response);
                      break;
                  case 404:
                    resolve(false);
                    break;
                }
              }
              reject(error_response);
        });
    });
  }


  getMostRecentByHorseId(horse_id: string): Promise<Horse_show_entry|boolean> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'most_recent_pending_entry_for_horse/horse_id/' + horse_id).subscribe((response:any) => {
        if(response.type == 'horse_show_entry' && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
              if(error_response instanceof HttpErrorResponse){
                switch (error_response.status) {
                  case 401:      //login
                      reject(error_response);
                      break;
                  case 403:     //forbidden
                      reject(error_response);
                      break;
                  case 404:
                    resolve(false);
                    break;
                }
              }
              reject(error_response);
        });
    });
  }

  getWithCompetitionsOnly(id: string): Promise<Horse_show_entry> {
    return this.getWithRestFragment('id/' + id + '/competitions/true/statement/false/lean/true');
  }

  private getWithRestFragment(rest_fragment: string): Promise<Horse_show_entry> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'pending_horse_show_entries/' + rest_fragment).subscribe((response:any) => {
        if(response.type == 'horse_show_entry' && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
              if(error_response instanceof HttpErrorResponse){
                reject(error_response.error);
              }
              reject(error_response);
        });
    });
  }


  getRiderList(entry_id: string): Promise<Person[]> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'pending_entry_riders/entry_id/' + entry_id).subscribe((response:any) => {

        if(response.type == 'user_person_list' && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
    });
  }

  create(horse_show_entry: Horse_show_entry): Promise<Horse_show_entry> {

    let post_data = {
        data: {
          type: 'horse_show_entry',
          attributes: { horse_show_entry: horse_show_entry }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'pending_horse_show_entries',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='horse_show_entry') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : JSON.stringify(error));
                  }
                });
            });

  }

  delete(entry_id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return this.http.delete(AppSettings.API_ENDPOINT + "pending_horse_show_entries/id/" + entry_id, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
        if(response.data && response.type=='pending_entry_delete_response') {
          resolve(response);
        } else {
          reject(response.data ? response.data : response);
        }
      }, error => {
        if(error instanceof HttpErrorResponse){
            reject(error.error);
          } else {
            reject(error);
          }
      });
    });
  }

  updateHorseOnEntry(entry_id: string, horse_id: string): Promise<boolean> {

      let put_data = {
          data: {type: 'horse_change_request',
          attributes: { entry_id: entry_id, horse_id: horse_id }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'pending_horse_show_entries',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='horse_change_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });

  }

  updatePersonOnEntry(entry_id: string, person_id: string, role: string, replaced_id?: string): Promise<boolean> {

      let put_data = {
          data: {type: 'person_change_request',
          attributes: { entry_id: entry_id, person_id: person_id, role: role, replaced_id: replaced_id }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'pending_horse_show_entries',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='person_change_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });

  }

  addRiderToEntry(entry_id: string, person_id: string): Promise<boolean> {

      let put_data = {
          data: {type: 'rider_add_request',
          attributes: { entry_id: entry_id, person_id: person_id}
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'pending_horse_show_entries',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='rider_add_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });
  }

  updatePayeeOnEntry(entry_id: string, payee_id: string): Promise<boolean> {
   let put_data = {
          data: {type: 'payee_change_request',
          attributes: { entry_id: entry_id, payee_id: payee_id }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'pending_horse_show_entries',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='payee_change_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });

  }

  updateAdditionalInformation(hs_entry: Horse_show_entry): Promise<boolean> {

    let add_info = {
      arrival_date: hs_entry.arrival_date,
      stable_with: hs_entry.stable_with,
      comments: hs_entry.comments,
      emergency_contact_name: hs_entry.emergency_contact_name,
      emergency_contact_number: hs_entry.emergency_contact_number,
      additional_fields: hs_entry.additional_fields
    };


    let put_data = {
          data: {type: 'information_update_request',
          attributes: { entry_id: hs_entry.id, info: add_info }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'pending_horse_show_entries',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='information_update_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });
  }


  getBlankHorseShowEntry(){
    return new Horse_show_entry({
      horse: new Horse({}),
      horse_list: [],
      owner: new Person({}),
      owner_list: [],
      trainer: new Person({}),
      trainer_list: [],
      rider_list: [],
      coach: new Person({}),
      barn_account: false,
      parent_list: [],
      signature_list: [],
      competition_entry_list: [],
      declaration_list: [],
      statement: new Statement({}),
      payee: new Person({}),
      payer: new Person({})
    });
  }


}
